// Values for the category options. The tags will be obtained from i18next: t(`categories.${value}`)
export const CATEGORY_VALUES = ['any', '27', '9', '10', '11', '12', '14', '15', '17', '18', '21', '22', '23', '31'];

// Values for the difficulty options. The labels will be obtained from i18next: t(`difficulties.${value}`)
export const DIFFICULTY_VALUES = ['easy', 'medium', 'hard', 'any'];

export const AMOUNT_OPTIONS_VALUES = [5, 10, 15, 20];
export const TIME_PER_QUESTION_OPTIONS_VALUES = [15, 30, 60];
